import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import CommomTagAndPillsCardBody from "../Common/CommomTagAndPillsCardBody";
import { NumberOfPillsTags } from "../../../../Constant";
import { ROUNDED_CONTEXT, ROUNDED_DATA } from "../../../../Data/UiKit/BadgesContextualVariations";

const NumberOfPillsTagCart = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={NumberOfPillsTags} span={ROUNDED_DATA} />
        <CommomTagAndPillsCardBody number={ROUNDED_CONTEXT} />
      </Card>
    </Col>
  )
};

export default NumberOfPillsTagCart;
